// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2-sno","overflowing":"ReadFullNote_overflowing__1Od-3"};